module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvklEQVRYhe2YQQrDMAwEN/1I+yT//+S8RCWQgyl1rHolnMIO+BJbyhBYYbKZGe7M49Z2EgwgSrAAqADsXPV8xnOEhFzF+hS2f0SKj6/17OztAF5M8wjBUYONaa4xw7JacJz+gBSP6NW50r8yJK70rxR01SkkLBJk+RTMu5XM8utcCpyDrrp2zMzeSlLHTCuY+qLZOqWYRYIsEmSRIIsEWf5KcL84t24v4LqVWvetqDYHq/MPVVqd/lGzSJACwBtAzdvrxWLS1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_recording_play.png
// module id = aJgY
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82